var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.57987 2.10799L22.1814 11.0044C22.7312 11.2673 22.9637 11.9262 22.7008 12.476C22.5921 12.7033 22.4088 12.8866 22.1814 12.9954L3.57987 21.8918C3.03007 22.1547 2.37122 21.9222 2.10827 21.3724C1.99401 21.1334 1.96948 20.8614 2.03916 20.6059L4.38626 11.9999L2.03916 3.39384C1.87881 2.80587 2.22545 2.19924 2.81342 2.03888C3.06892 1.9692 3.34096 1.99373 3.57987 2.10799ZM3.44356 3.51064L5.58236 11.3567L15.2418 11.3576C15.577 11.3576 15.8541 11.6067 15.8979 11.9298L15.9039 12.0197C15.9039 12.3549 15.6549 12.6319 15.3317 12.6757L15.2418 12.6818L5.57177 12.6809L3.44356 20.4891L21.1938 11.9999L3.44356 3.51064Z",
    fill: "#3D3839"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start_icon.b1931a73228d175a6fd1616ddff7e114.svg";
export { ForwardRef as ReactComponent };